module.exports = __webpack_public_path__ + "img/programOverview2.fb8c5092.png";